export function buildSocketHeaders(
  token: string | undefined,
  currentRole: string | undefined,
  extraHeaders: Record<string, unknown> | undefined
): Record<string, string> {
  const headers: Record<string, string> = {
    'x-hasura-role': currentRole || '',
    authorization: token ? `Bearer ${token}` : ''
  };

  for (const [key, value] of Object.entries(extraHeaders ?? {})) {
    if (value !== null && value !== undefined && String(value).length > 0) {
      headers[key] = String(value);
    }
  }

  return headers;
}
